const cartPopupElem = document.querySelector('.cart-popup');
const cartModuleElem = document.querySelector('.cart-module');
const checkoutCartElem = document.querySelector('.purchase-process-sidebar');
// *******************************************************************************
// Update Cart on change
// *******************************************************************************
const updateCartOnChange = (data, source) => {
  if (source === 'popup') {
    document.querySelector('.cart-popup .cart-popup__content').innerHTML = data;
  } else if (source === 'cartPage') {
    document.querySelector('.cart-module .cart-module__inner').innerHTML = data;
  } else if (source === 'checkout') {
    document.querySelector('.purchase-process-sidebar__products').innerHTML = data;
  }
};

// **********************************************************
// update cart count in header
// **********************************************************
const updateCartNumber = (number) => {
  const cartIconEl = document.querySelectorAll('.header-main__cart');
  cartIconEl.forEach((item) => {
    const cartIconNumberEl = item.querySelector('.header-main__icon-items');
    if (cartIconNumberEl) {
      if (number === 0) {
        cartIconNumberEl.remove();
      } else {
        cartIconNumberEl.innerHTML = `<p>${number}</p>`;
      }
    } else {
      if (number !== 0) {
        const cartIconNumberElNew = document.createElement('div');
        cartIconNumberElNew.classList.add('header-main__icon-items');
        cartIconNumberElNew.classList.add('header-main__right-link__number');
        cartIconNumberElNew.classList.add('d-flex-cc');
        cartIconNumberElNew.innerHTML = `<p>${number}</p>`;
        item.appendChild(cartIconNumberElNew);
      }
    }
  });
};

if (cartPopupElem || cartModuleElem || checkoutCartElem) {
  // **********************************************************
  // Open Cart Popup
  // **********************************************************

  attachEvent('.cart-popup-trigger', 'click', (ev) => {
    const cartPopup = document.querySelector('.cart-popup');
    if (!document.querySelector('.purchase-process')) {
      if (cartPopup) {
        const isOpen = cartPopup.classList.contains('is-cart-open');
        cartPopup.classList.toggle('is-cart-open', !isOpen);
        toggleBodyScrollLock(!isOpen);
      }
      ev.preventDefault();
    }
  });

  // **********************************************************
  // Close Popup When Escape Key Press
  // **********************************************************

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const cartPopupEle = document.querySelectorAll('.cart-popup');
      if (cartPopupEle.length > 0) {
        cartPopupEle.forEach((el) => {
          el.classList.remove('is-cart-open');
          toggleBodyScrollLock(false);
        });
      }
    }
  });

  // **********************************************************
  // Close Popup When Click On Outside
  // **********************************************************

  attachEvent('.cart-popup__overlay, .cart-popup__close', 'click', (ev) => {
    const parentEle = ev.target.closest('.cart-popup');
    parentEle.classList.remove('is-cart-open');
    ev.preventDefault();
    toggleBodyScrollLock(false);
  });

  // **********************************************************
  // Change Item Quantity In Popup Cart
  // **********************************************************
  // Axios add/remove item quantity from cart
  const axiosChangeQuantityInCart = async (newAmountData, source) => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'changeItemQuantityInCart');
    formDataInput.append('inputs', JSON.stringify(newAmountData));
    formDataInput.append('id', localData.id);
    formDataInput.append('source', source);
    if (source === 'checkout') {
      formDataInput.append('perks', JSON.stringify(getInputData()));
    }
    formDataInput.append(
      'current',
      document.querySelector('.free-shipping-indicator__progress-bar-inner')?.style.width,
    );

    try {
      const response = await axios.post(localData.apiURL, formDataInput);
      if (source === 'checkout' && !response.data.data.cart_contents_count) {
        window.location.reload();
        return;
      }
      updateCartOnChange(response.data.data.cart_content_html, source);
      updateCartNumber(response.data.data.cart_contents_count);
      if (source === 'checkout') {
        promoCodeSuccess(
          response.data.data.cart_prices_html,
          response.data.data.free_shipping_indicator_html,
          response.data.data.delivery_prices,
          response,
        );
        await axiosCalculateTotals();
        if (document.querySelector('.sc-purchase-process-info-02')) {
          reInitPayMethods();
        }
        return;
      }
      document
        .querySelector('.cart-popup')
        ?.classList.toggle('cart-popup--empty', !response.data.data.cart_contents_count);
      const data = response.data.data.like;
      if (data) {
        const likedIds = (data.liked || []).map(String);
        const wishlistCount = data.wishlistCount || 0;

        document.querySelectorAll('[data-wishlist-count]').forEach((i) => {
          i.innerHTML = i.querySelector('p') ? `<p>${wishlistCount}</p>` : String(wishlistCount);
          i.style.display = wishlistCount ? '' : 'none';
        });

        document.querySelectorAll('.product-card__wishlist').forEach((btn) => {
          if (likedIds.includes(String(btn.dataset.productId))) {
            btn.classList.add('is-active');
          }
        });

        document.querySelectorAll('.product-module__wishlist').forEach((btn) => {
          if (likedIds.includes(String(btn.dataset.productId))) {
            btn.classList.add('is-active');
          }
        });
      }
      setTimeout(() => {
        const progressBars = document.querySelectorAll('.free-shipping-indicator__progress-bar');
        progressBars.forEach((bar) => {
          const inner = bar.querySelector('.free-shipping-indicator__progress-bar-inner');
          if (inner && bar.dataset.end) {
            inner.style.width = `${bar.dataset.end}%`;
          }
        });
      }, 20);
    } catch (err) {
      console.error(err);
    }
  };

  // Change Item Quantity Debounce
  const debounceAxiosChangeQuantityInCart = debounce((newAmountData, source) =>
    axiosChangeQuantityInCart(newAmountData, source),
  );

  const hasWordPressLoginCookie = document.cookie.split(';').some((cookie) => {
    const name = cookie.trim().split('=')[0];
    return (
      name.startsWith('wordpress_logged_in_') ||
      name.startsWith('woocommerce_cart_hash') ||
      name.startsWith('wp-settings-time-') ||
      name.startsWith('wordpress_test_cookie') ||
      name.startsWith('wp_woocommerce_session_')
    );
  });
  // click on add/remove item quantity button
  attachEvent('.quantity-counter__button--remove:not(.is-disabled), .quantity-counter__button--add', 'click', (ev) => {
    setTimeout(() => {
      if (!ev.target.closest('.cart-view__item')) {
        return;
      }
      const newAmountData = {
        cart_item_key: ev.target.closest('.cart-view__item').querySelector('.cart-item-key')?.value,
        quantity: ev.target.closest('.quantity-counter').querySelector('.quantity-counter__input').value,
      };
      if (!newAmountData.cart_item_key) {
        return;
      }
      const source = ev.target.closest('.purchase-process-sidebar')
        ? 'checkout'
        : ev.target.closest('.cart-popup') ? 'popup' : 'cartPage';
      debounceAxiosChangeQuantityInCart(newAmountData, source);
    }, 10);
  });

  if (!document.querySelector('header.header-main--purchase-process')) {
    if (document.querySelector('.sc-cart-module')) {
      axiosChangeQuantityInCart({}, 'cartPage');
      document.querySelector('.cart-popup-trigger')?.style.setProperty('pointer-events', 'none');
    } else {
      const wishlistItems = Cookies.get(`wishlist_items_${localData.lang}`);
      if ((wishlistItems && wishlistItems !== '[]') || hasWordPressLoginCookie) {
        axiosChangeQuantityInCart({}, 'popup');
      }
    }
  }
}
